<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.errorLogList.push"
    :is-show-search-input="false"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id" width="100px"/>
    <el-table-column label="错误内容" prop="content"/>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.errorLogDetail.to(row.id)" icon="browse" name="查看"/>
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`error-log-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span class="flex-shrink">错误内容</span>
              <span class="list-item-info">{{ v.content }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.errorLogDetail.to(v.id)" icon="browse" name="查看"/>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index } from '@/api/error-log';

export default {
  name: RouteConfig.errorLogList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
